import React from 'react';

const MealDealPage = () => {
	return <div className='meal-deal-page'>Under Construction</div>;
};

export default MealDealPage;
